// Keeps the open "Anmeldelser" accordion panel at full height as the Judge.me
// review widget hydrates and paginates. The widget mounts async with no load
// callback; the panel animates via max-height and only settles to `none` on
// transitionend, so if the widget grows (or the panel opens before the widget
// has rendered) re-assert the open height.
(function () {
  const widget = document.getElementById('judgeme_product_reviews');
  if (!widget) return;

  const content = widget.closest('[data-acc-content]');
  const item = widget.closest('[data-acc-item]');
  if (!content || !item) return;

  let raf;
  function resync() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      if (item.classList.contains('active') && !content.hidden) {
        content.style.maxHeight = 'none';
      }
    });
  }

  new MutationObserver(resync).observe(widget, { childList: true, subtree: true });
})();
